// api
import { fetchApi } from '@/api'
// actions
const retainedsAll = (context) => {
  let url = 'retaineds/retaineds'
  let data = {}
  fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('RETAINEDS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const retainedsForm = (context) => {
  let url = 'retaineds/retaineds/create'
  let data = {}
  fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('RETAINEDS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const retainedsShow = (context) => {
  let url = 'retaineds/retaineds'
  let data = {}
  fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('RETAINEDS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const retainedsCreate = (context) => {
  let url = 'retaineds/retaineds/create'
  let data = {}
  fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('RETAINEDS_CREATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const retainedsUpdate = (context) => {
  let url = 'retaineds/retaineds'
  let data = {}
  fetchApi(url, data, 'PUT')
    .then((response) => {
      context.commit('RETAINEDS_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const retainedsDelete = (context, payload) => {
  let url = 'retaineds/retaineds'
  console.log(payload)
  fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('RETAINEDS_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  retainedsAll,
  retainedsForm,
  retainedsShow,
  retainedsCreate,
  retainedsUpdate,
  retainedsDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/retaineds/actions.js